import styled from 'styled-components'
import { Drawer as DrawerAnt } from 'antd'
import { P } from 'konsys-ui'
import { theme } from '../../styles/_variables'

export const ContainerWrapper = styled.div`
  max-width: ${theme.maxWidth};
  margin: 0 auto;
  padding: 32px;
`

export const ImageLogo = styled.img`
  height: 63px;
`

export const MenuIcon = styled.i`
  font-size: ${theme.fonts.size.subTitle};
  cursor: pointer;
`
export const MenuItem = styled(P)`
  cursor: pointer;
  display: block;
  padding-left: 24px;
`

export const Drawer = styled(DrawerAnt)`
  .ant-drawer-body {
    padding: 0;
    padding-top: 72px;
  }
`

export const Iconn = styled.i`
  color: red;
`

export default ContainerWrapper



// WEBPACK FOOTER //
// ./src/components/container/styled.js